module.exports = __webpack_public_path__ + "img/image8.bce19cb1.png";